/* istanbul ignore file */
// no business logic, will cover it with TODO: cypress
import { createButtonComponent } from '@vfde-brix/button';
import { formValidation } from '@vfde-brix/core';
import { createInputFieldComponent, InputField } from '@vfde-brix/input-field';
import {
    CONTAINER_INPUT_CITY,
    CONTAINER_INPUT_COMPANY,
    CONTAINER_INPUT_CONFIRMATION,
    CONTAINER_INPUT_DISTRICT,
    CONTAINER_INPUT_EMAIL,
    CONTAINER_INPUT_FIRSTNAME,
    CONTAINER_INPUT_FLOORNUMBER,
    CONTAINER_INPUT_HOUSE_NUMBER,
    CONTAINER_INPUT_LANSTNAME,
    CONTAINER_INPUT_NUMBER_OF_BUSINESS_UNIT,
    CONTAINER_INPUT_NUMBER_OF_RESIDENCE,
    CONTAINER_INPUT_PERSONAL_BIRTHDAY,
    CONTAINER_INPUT_PERSONAL_CITY,
    CONTAINER_INPUT_PERSONAL_HOUSE_NUMBER,
    CONTAINER_INPUT_PERSONAL_STREET,
    CONTAINER_INPUT_PERSONAL_ZIPCODE,
    CONTAINER_INPUT_REPRESENTED_BY,
    CONTAINER_INPUT_REPRESENTED_BY_BIRTHDAY,
    CONTAINER_INPUT_REPRESENTED_BY_CITY,
    CONTAINER_INPUT_REPRESENTED_BY_COMPANY,
    CONTAINER_INPUT_REPRESENTED_BY_EMAIL,
    CONTAINER_INPUT_REPRESENTED_BY_FIRSTNAME,
    CONTAINER_INPUT_REPRESENTED_BY_HOUSE_NUMBER,
    CONTAINER_INPUT_REPRESENTED_BY_LASTNAME,
    CONTAINER_INPUT_REPRESENTED_BY_STREET,
    CONTAINER_INPUT_REPRESENTED_BY_ZIPCODE,
    CONTAINER_INPUT_SELECTION_SEX, CONTAINER_INPUT_STREET,
    CONTAINER_INPUT_SUBMIT,
    CONTAINER_INPUT_ZIPCODE,
    CONTAINER_PHONE_AREA_CODE,
    CONTAINER_PHONE_NUMBER,
    CONTAINER_REPRESENTED_BY_PHONE_AREA_CODE,
    CONTAINER_REPRESENTED_BY_PHONE_NUMBER,
    DATE_VALIDATION_CONFIG,
    EMAIL_VALIDATION_CONFIG,
    GENERAL_MAX_LENGTH_VALIDATION_CONFIG,
    MAX_LENGTH_CITY_VALIDATION_CONFIG,
    MAX_LENGTH_HOUSE_NUMBER_CONFIG,
    MAX_LENGTH_PHONE_AREA_VALIDATION_CONFIG,
    MAX_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG,
    MAX_LENGTH_STREET_VALIDATION_CONFIG,
    MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
    MIN_LENGTH_HOUSE_NUMBER_CONFIG,
    MIN_LENGTH_PHONE_AREA_VALIDATION_CONFIG,
    MIN_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG,
    MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
    ONLYNUMBERS_VALIDATION_CONFIG,
    REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG,
    REQUIRED_CONFIRM_CHECKBOX_CONFIG,
    REQUIRED_VALIDATION_CONFIG,
    RESIDENTIAL_OR_BUSINESS_UNIT_VALIDATION_CONFIG,
    SECURE_VALUE_VALIDATION_CONFIG,
} from 'Constant';
import { IInputConfiguration } from '../interface';

/**
 * renderLandUseForm - mounts/renders the land use contract form
 * @param action - dispachable acitons to connect to the state
 */
export const mountLandUseForm = (action) => {
    const formFields: InputField[] = [];

    const inputConfigurations: IInputConfiguration[] = [
        {
            id: CONTAINER_INPUT_SELECTION_SEX,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({title: value}); },
            validation: [REQUIRED_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_FIRSTNAME,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({firstname: value}); },
            validation: [REQUIRED_VALIDATION_CONFIG, GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_LANSTNAME,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({lastname: value}); },
            validation: [REQUIRED_VALIDATION_CONFIG, GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_COMPANY,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({company: value}); },
            validation: [GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_PERSONAL_STREET,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({personalStreet: value}); },
            validation: [REQUIRED_VALIDATION_CONFIG, MAX_LENGTH_STREET_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_PERSONAL_HOUSE_NUMBER,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({personalHouseNumber: value}); },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                MIN_LENGTH_HOUSE_NUMBER_CONFIG,
                MAX_LENGTH_HOUSE_NUMBER_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_PERSONAL_ZIPCODE,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({personalZipcode: value}); },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                ONLYNUMBERS_VALIDATION_CONFIG,
                MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
                MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_PERSONAL_CITY,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({personalCity: value}); },
            validation: [REQUIRED_VALIDATION_CONFIG, MAX_LENGTH_CITY_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        // Use fix value from constants, Jira ticket: https://jira.wf-de.vodafone.com/projects/ADTDXC6/issues/ADTDXC6-531
        // {
        //     id: CONTAINER_INPUT_PERSONAL_COUNTRY,
        //     onChange: (event: Event, value: string) => { action.saveRegistrationData({personalCountry: value}); },
        //     validation: [REQUIRED_VALIDATION_CONFIG, GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        // },
        {
            id: CONTAINER_INPUT_PERSONAL_BIRTHDAY,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({personalBirthday: value}); },
            validation: [REQUIRED_VALIDATION_CONFIG, DATE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_EMAIL,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({email: value}); },
            validation: [REQUIRED_VALIDATION_CONFIG, EMAIL_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_PHONE_AREA_CODE,
            onChange: (event: Event, value: string) => {
                const checkbox = event.target as HTMLInputElement;
                action.saveRegistrationData({phoneAreaCode: value});
            },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                ONLYNUMBERS_VALIDATION_CONFIG,
                MIN_LENGTH_PHONE_AREA_VALIDATION_CONFIG,
                MAX_LENGTH_PHONE_AREA_VALIDATION_CONFIG,
            ],
        },
        {
            id: CONTAINER_PHONE_NUMBER,
            onChange: (event: Event, value: string) => {
                const checkbox = event.target as HTMLInputElement;
                action.saveRegistrationData({phoneNumber: value});
            },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                ONLYNUMBERS_VALIDATION_CONFIG,
                MIN_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG,
                MAX_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY,
            onChange: (event: Event, value: string) => {
                const checkbox = event.target as HTMLInputElement;
                action.saveRegistrationData({representedByCheck: checkbox.checked});
            },
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_FIRSTNAME,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByFirstname: value}); },
            validation: [REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG, GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_LASTNAME,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByLastname: value}); },
            validation: [REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG, GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_COMPANY,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByCompany: value}); },
            validation: [GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_STREET,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByStreet: value}); },
            validation: [REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG, MAX_LENGTH_STREET_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_HOUSE_NUMBER,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByHouseNumber: value}); },
            validation: [
                REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG,
                MIN_LENGTH_HOUSE_NUMBER_CONFIG,
                MAX_LENGTH_HOUSE_NUMBER_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_ZIPCODE,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByZipcode: value}); },
            validation: [
                REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG,
                ONLYNUMBERS_VALIDATION_CONFIG,
                MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
                MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_CITY,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByCity: value}); },
            validation: [REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG, MAX_LENGTH_CITY_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        // Use fix value from constants, Jira ticket: https://jira.wf-de.vodafone.com/projects/ADTDXC6/issues/ADTDXC6-531
        // {
        //     id: CONTAINER_INPUT_REPRESENTED_BY_COUNTRY,
        //     onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByCountry: value}); },
        //     validation: [REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG, GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        // },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_BIRTHDAY,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByBirthday: value}); },
            validation: [REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG, DATE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_REPRESENTED_BY_EMAIL,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({representedByEmail: value}); },
            validation: [REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG, EMAIL_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_REPRESENTED_BY_PHONE_AREA_CODE,
            onChange: (event: Event, value: string) => {
                const checkbox = event.target as HTMLInputElement;
                action.saveRegistrationData({representedByPhoneAreaCode: value});
            },
            validation: [
                REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG,
                ONLYNUMBERS_VALIDATION_CONFIG,
                MIN_LENGTH_PHONE_AREA_VALIDATION_CONFIG,
                MAX_LENGTH_PHONE_AREA_VALIDATION_CONFIG,
            ],
        },
        {
            id: CONTAINER_REPRESENTED_BY_PHONE_NUMBER,
            onChange: (event: Event, value: string) => {
                const checkbox = event.target as HTMLInputElement;
                action.saveRegistrationData({representedByPhoneNumber: value});
            },
            validation: [
                REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG,
                ONLYNUMBERS_VALIDATION_CONFIG,
                MIN_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG,
                MAX_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_STREET,
            // Do not trigger the save action as the value will be set at once initially from session storage
            onChange: (event: Event, value: string) => { /*action.saveRegistrationData({street: value});*/ },
            validation: [REQUIRED_VALIDATION_CONFIG, MAX_LENGTH_STREET_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_HOUSE_NUMBER,
            // Do not trigger the save action as the value will be set at once initially from session storage
            onChange: (event: Event, value: string) => { /*action.saveRegistrationData({houseNumber: value});*/ },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                MIN_LENGTH_HOUSE_NUMBER_CONFIG,
                MAX_LENGTH_HOUSE_NUMBER_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_ZIPCODE,
            // Do not trigger the save action as the value will be set at once initially from session storage
            onChange: (event: Event, value: string) => { /*action.saveRegistrationData({zipcode: value});*/ },
            validation: [
                REQUIRED_VALIDATION_CONFIG,
                ONLYNUMBERS_VALIDATION_CONFIG,
                MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
                MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG,
            ],
        },
        {
            id: CONTAINER_INPUT_CITY,
            // Do not trigger the save action as the value will be set at once initially from session storage
            onChange: (event: Event, value: string) => { /*action.saveRegistrationData({city: value});*/ },
            validation: [REQUIRED_VALIDATION_CONFIG, MAX_LENGTH_CITY_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_FLOORNUMBER,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({floornumber: value}); },
            validation: [GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_DISTRICT,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({district: value}); },
            validation: [GENERAL_MAX_LENGTH_VALIDATION_CONFIG, SECURE_VALUE_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_NUMBER_OF_RESIDENCE,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({nubmerOfResidence: value}); },
            validation: [ONLYNUMBERS_VALIDATION_CONFIG, RESIDENTIAL_OR_BUSINESS_UNIT_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_NUMBER_OF_BUSINESS_UNIT,
            onChange: (event: Event, value: string) => { action.saveRegistrationData({nubmerOfBusinessUnit: value}); },
            validation: [ONLYNUMBERS_VALIDATION_CONFIG, RESIDENTIAL_OR_BUSINESS_UNIT_VALIDATION_CONFIG],
        },
        {
            id: CONTAINER_INPUT_CONFIRMATION,
            onChange: (event: Event, value: string) => {
                const checkbox = event.target as HTMLInputElement;
                action.saveRegistrationData({confirmation: checkbox.checked});
            },
            validation: [REQUIRED_CONFIRM_CHECKBOX_CONFIG],
        },
    ];

    for (const config of inputConfigurations) {
        const { id, onChange, validation } = config;

        formFields.push(createInputFieldComponent(document.getElementById(id), { onChange, validation }));
    }

    const submitButton = createButtonComponent(document.getElementById(CONTAINER_INPUT_SUBMIT), {
        onClick: (event: Event, value: string) => {
            action.sendRegistrationData();
        },
    });

    const formToValidate = {
        formFields,
        submitButton,
    };
    formValidation(formToValidate);
};
